import $ from 'jquery';

let xhr;

const updateQueryParams = function () {
  const query = $('#query').val();
  const params = $('#search-filter-form').serialize();

  updateHistory(params);
};

const updateHistory = function (params) {
  if (window.history && typeof window.history.pushState == 'function') {
    window.history.pushState({}, '', `${window.location.pathname}?${params}`);
  } else {
    window.location.search = params;
  }
};

const updateFilterOptions = function (filterGroup, $oldFilters, $newFilters, filterGroupClass = 'md-search-filter-group') {
  const $oldFilterGroup = $oldFilters.find(`.${filterGroupClass}.${filterGroup}`);
  const $newFilterGroup = $newFilters.find(`.${filterGroupClass}.${filterGroup}`);

  $oldFilterGroup.empty().append($newFilterGroup.children());
};

const updateFilterVisibility = function (filterGroup, $oldFilters, $newFilters) {
  const $oldFilterGroup = $oldFilters.find(`.md-search-results__sidebar__filter.${filterGroup}`);
  const $newFilterGroup = $newFilters.find(`.md-search-results__sidebar__filter.${filterGroup}`);

  if ($newFilterGroup.hasClass('hide')) {
    $oldFilterGroup.addClass('hide');
  } else {
    $oldFilterGroup.removeClass('hide');
  }
}

const updateFilters = function ($newFilters) {
  const $oldFilters = $('#search-filter-form');
  updateFilterOptions('section', $oldFilters, $newFilters);
  updateFilterOptions('equipment', $oldFilters, $newFilters);
  updateFilterOptions('equipment-sub', $oldFilters, $newFilters);
  updateFilterOptions('material', $oldFilters, $newFilters);
  updateFilterOptions('material-sub', $oldFilters, $newFilters);
  updateFilterOptions('consumable', $oldFilters, $newFilters);
  updateFilterOptions('consumable-sub', $oldFilters, $newFilters);
  updateFilterOptions('service', $oldFilters, $newFilters);
  updateFilterOptions('service-sub', $oldFilters, $newFilters);
  updateFilterOptions('az-index', $oldFilters, $newFilters);
  updateFilterOptions('location', $oldFilters, $newFilters, 'md-search-results__sidebar__sortby');

  updateFilterVisibility('equipment', $oldFilters, $newFilters);
  updateFilterVisibility('materials', $oldFilters, $newFilters);
  updateFilterVisibility('consumables', $oldFilters, $newFilters);
  updateFilterVisibility('services', $oldFilters, $newFilters);
};

const removeFilter = function (name, value) {
  const $filter = $(`input[name="${name}[]"][value="${value}"]`);

  if ($filter.is(':checked')) {
    $filter.click();
    clearSubFilters($filter);
  }
};

const clearSubFilters = function ($filter) {
  const $filterContainer = $filter.closest('.md-search-checkboxes__item');
  const $checkedSubFilters = $filterContainer.find('.md-search-checkboxes__sub-item input[type=checkbox]:checked');

  $checkedSubFilters.click();
};

// Keep main search query and the query filter form in sync
$('#main-search-query').on('change', function () {
  const $filterQuery = $('#query')
  $filterQuery.val($('#main-search-query').val());
});

$(document).on('change', '#query', function () {
  const $mainQuery = $('#main-search-query');
  $mainQuery.val($('#query').val());
});

// Submit full search filter form instead of main search query
$(document).on('submit', '#main-search-form', function (event) {
  event.preventDefault();
  const $filterQuery = $('.search-filter-query');
  $filterQuery.val($('#main-search-query').val());
  $('#search-filter-form').submit();
});

$(document).on('submit', '#search-filter-form', function (event) {
  event.preventDefault();

  const $submit = $(this);
  const params = $submit.serialize();

  if (xhr) {
    xhr.abort();
  }
  xhr = new window.XMLHttpRequest();

  $('.md-search-results__loading-overlay').addClass('loading');

  $.ajax({
    url: '/search',
    xhr: function () {
        return xhr;
    },
    data: params,
    success: function (response) {
      const $newList = $(response).find('.md-search-results__main');
      const $newFilters = $(response).find('#search-filter-form');
      $('.md-search-results__main').replaceWith($newList);
      updateFilters($newFilters);
      updateQueryParams();
      $('.md-search-results__loading-overlay').removeClass('loading');
      xhr = undefined;
    }
  });
});

// Location Filters
$(document).on('change', '#country', function (event) {
  const $stateOptions = $('#state').find('option');
  const $cityOptions = $('#city').find('option');
  $stateOptions.prop('selected', false);
  $cityOptions.prop('selected', false);
});

$(document).on('change', '#state', function (event) {
  const $cityOptions = $('#city').find('option');
  $cityOptions.prop('selected', false);
});

// A-Z Index
$(document).on('click', '.letter-link', function (event) {
  event.preventDefault();
  const isAvailable = $(this).parent().hasClass('available');

  if (!isAvailable) {
    return;
  }

  const letter = $(this).data('letter');
  const $radio = $('.letter-radio[value=' + letter + ']');

  $('.letter').removeClass('selected');
  $(this).parent().addClass('selected');

  if (letter == 'All') {
    $('.letter-radio').prop('checked', false);
  } else {
    $radio.prop('checked', true);
  }

  $("#search-filter-form").submit();
});

// Show and Hide Filter Groups
$(document).on('click', '.md-search-filter-action', function() {
  $(this).closest('h2').next('.md-search-filter-group').toggle();
  $(this).toggleClass('close');
});

// Show and Hide Category Groups
$(document).on('click', '.md-category-toggle-action', function() {
  $(this).closest('.md-categories-toggle').next('.md-categories-parent__list > ul').toggle();
  $(this).toggleClass('close');
});

// Submit filters on change
$(document).on('change', '#search-filter-form', function () {
  $(this).submit();
});

// Remove association filter when clicking X on filter tags
$(document).on('click', '.md-results-tag-filter__tag button', function () {
  const $tag = $(this).closest('.md-results-tag-filter__tag');
  const name = $(this).data('name');
  const value = $(this).data('value');

  if (name == 'query') {
    $('#query').val('');
    $('#search-filter-form').submit();
  } else {
    removeFilter(name, value);
  }
});

$(document).on('click', 'input[type=checkbox]', function () {
  if (['group[]', 'category[]'].indexOf($(this).attr('name')) < 0) {
    return;
  }

  clearSubFilters($(this));
});



// WEBPACK FOOTER //
// ./lib/assets/js/search.js